module.exports = __webpack_public_path__ + "img/bJeOHGbF.87760c65.svg";